/**
 * Default skeleton for a new iaAgent document.
 * Mirrors the Cosmos DB schema so the backend stores consistent data.
 * Fields filled by the admin override these defaults.
 */
export const emptyIaAgentObject = {
  id: "",
  displayName: "",
  type: "iaAgent",
  scope: "default",
  region: "",
  dataLocation: "",
  timeZone: "",
  enabled: true,

  agentPersonality: {
    name: "",
    role: "",
    company: "",
    personality: "friendly-casual",
    languageStyle: "formal-polite",
    voice: "marin",
  },

  behaviorRules: {
    general: [
      "Never interrupt or cut off the user",
      "Respond in maximum 2 sentences each time",
      "Remain courteous and professional at all times",
    ],
    greeting: {
      mandatory: true,
      format: "Hello, I'm {name}, {role} at {company}! How can I help you today?",
      includeAllElements: true,
    },
    languageAdaptation: {
      enabled: true,
      supportedLanguages: ["English", "French"],
      defaultLanguage: "En",
      detectionProtocol: [
        "1. Detect the language from the first words",
        "2. Switch immediately to that language",
        "3. Rephrase the user's question to confirm",
        "4. Continue the entire conversation in that language",
        "5. Never mix multiple languages",
      ],
    },
    responseFormat: {
      maxSentences: 2,
      avoidRepetition: true,
      confirmBeforeAction: true,
    },
  },

  skills: {
    userSearch: {
      enabled: true,
      tool: "search_user",
      description: "Search for a user in the Microsoft Teams directory",
      requireConfirmation: false,
      autoExecute: true,
    },
    userPresence: {
      enabled: true,
      tool: "get_user_presence",
      description: "Check a user's availability",
      requireConfirmation: false,
      autoExecute: true,
      announceStatus: true,
    },
    transferToUser: {
      enabled: true,
      tool: "transfer_to_user",
      description: "Transfer the call to a Microsoft Teams user",
      requireConfirmation: true,
    },
    transferToPhone: {
      enabled: false,
      tool: "transfer_to_phone",
      description: "Transfer to an external phone number",
      requireConfirmation: true,
    },
    hangupCall: {
      enabled: true,
      tool: "hangup_call",
      description: "End the call",
      requireConfirmation: false,
      farewellMessage: "Goodbye and have a great day!",
      mandatory: true,
    },
    leaveMessage: {
      enabled: true,
      tool: "leave_message",
      description: "Take a message for an absent user",
      requireConfirmation: false,
      captureInfo: ["caller_name", "phone_number", "message"],
    },
    callQualification: {
      enabled: false,
      tool: "escalate_to_agent",
      strategy: "conversational",
      clarifyBeforeRouting: true,
      maxClarifyingQuestions: 1,
      routes: [],
      fallback: {
        behavior: "ask_clarification",
        disambiguationMessage: { en: "", fr: "" },
        ifStillUnclear: { queueId: "", reason: "" },
      },
      rules: [],
    },
  },

  knowledgeBase: {
    enabled: false,
    name: "",
    language: "en",
    type: "inline",
    data: [],
    usageInstructions: "",
    fallbackMessage: "",
  },

  securityRules: [],

  errorHandling: {
    maxRetries: 3,
    fallbackToHuman: true,
    fallbackQueueId: "",
    errorMessages: {
      userNotFound: "",
      transferFailed: "",
      technicalError: "",
      timeout: "",
    },
  },
};
